
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as accountvSF4JG1laNMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/account.vue?macro=true";
import { default as complete_45accounte1FJFd9m83Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/complete-account.vue?macro=true";
import { default as forgot_45passwordf7is5a9jcNMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/forgot-password.vue?macro=true";
import { default as homeHoePjH8bA6Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/home.vue?macro=true";
import { default as indexcpQ8zTU3ZFMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/index.vue?macro=true";
import { default as loginrXwSMwVJ7KMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/login.vue?macro=true";
import { default as notificationsDNpDGgHymnMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/notifications.vue?macro=true";
import { default as reset_45passwordIiCxe9p0FFMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/reset-password.vue?macro=true";
import { default as client_45filtersW7mmvIygSNMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue?macro=true";
import { default as client_45groupssDHwQ9nCRhMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue?macro=true";
import { default as _91id_93g4vhNijwClMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue?macro=true";
import { default as indexc9mtd8sZ3WMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue?macro=true";
import { default as _91id_93PF6JTihuQ4Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue?macro=true";
import { default as clientsj3k5RsLPrjMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue?macro=true";
import { default as delivery_45sheets4tbXAbIYyVMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue?macro=true";
import { default as indexBtDfGk3aS8Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue?macro=true";
import { default as newjXhsoVbm7LMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue?macro=true";
import { default as exportKD3kjuXGp5Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue?macro=true";
import { default as indexsnyStGrJo6Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue?macro=true";
import { default as newv63l8MjWjuMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue?macro=true";
import { default as _91id_93SG005yz98PMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue?macro=true";
import { default as import1TwmsfioAIMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue?macro=true";
import { default as indexcf83ZRNoiEMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue?macro=true";
import { default as createk8JPH6t4idMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue?macro=true";
import { default as _91id_939BfnrNxliMMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue?macro=true";
import { default as _91id_93ry4Hb4xLnUMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue?macro=true";
import { default as indexLTVnjaWbLmMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue?macro=true";
import { default as inventoriesjKO0B0H8UTMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue?macro=true";
import { default as inventoryRXsUnJlGH7Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue?macro=true";
import { default as indexIOSxZ4UdCbMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue?macro=true";
import { default as activity8CyrsMmuSkMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue?macro=true";
import { default as burndowntp5jcQQhL2Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue?macro=true";
import { default as index9jiidyCvVUMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue?macro=true";
import { default as reportingYN1wEZIGyvMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue?macro=true";
import { default as _91id_935XhwXgbAnbMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue?macro=true";
import { default as indexr0HvhROOaUMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue?macro=true";
import { default as appointmentsRHfTaMDERyMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue?macro=true";
import { default as index7XpsY4WC7SMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue?macro=true";
import { default as _91id_93R1NLGj23kWMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue?macro=true";
import { default as client_45assignmentU3Bx9OfAN4Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue?macro=true";
import { default as client_45dashboardbXSh3FCgSNMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue?macro=true";
import { default as indexy73hHT9PABMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue?macro=true";
import { default as _91id_93YTAB3ZG8zoMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue?macro=true";
import { default as collaboratorsYmFLIYY9gAMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue?macro=true";
import { default as indexBH2WhOIIesMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue?macro=true";
import { default as roadmapLHK3lbmpMnMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue?macro=true";
import { default as indexgQuMuWvTTwMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue?macro=true";
import { default as tasksLxnCnjw7Q6Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue?macro=true";
import { default as rolloutlT1PXgyBUYMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue?macro=true";
import { default as schedule_45appointmentS5HIZm2uh6Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/schedule-appointment.vue?macro=true";
import { default as brandingPjm9r4q0JOMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/branding.vue?macro=true";
import { default as createI0QiafV9KQMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists/create.vue?macro=true";
import { default as _91id_932ANDu0xKQcMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists/edit/[id].vue?macro=true";
import { default as indexbQJuXbcKa9Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists/index.vue?macro=true";
import { default as checklists7zD7u2aISeMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists.vue?macro=true";
import { default as client_45linksaRe5LwbYU5Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/client-links.vue?macro=true";
import { default as custom_45fieldsl70iP2ESLEMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/custom-fields.vue?macro=true";
import { default as index8FTFDc6bUfMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/index.vue?macro=true";
import { default as integrationsMGnxqdBQCPMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/integrations.vue?macro=true";
import { default as rolloutsNfusYJWkNFMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/rollouts.vue?macro=true";
import { default as subscriptiony8li3Wb2wOMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/subscription.vue?macro=true";
import { default as usersq8PvKeiuZIMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/users.vue?macro=true";
import { default as createkUSyUIDvM6Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows/create.vue?macro=true";
import { default as _91id_93I4MTFX69B9Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows/edit/[id].vue?macro=true";
import { default as index1rISvcDNlWMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows/index.vue?macro=true";
import { default as workflowsl0twXuKLX9Meta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows.vue?macro=true";
import { default as settings0WAvRF9SwcMeta } from "/codebuild/output/src3758341090/src/packages/frontend/pages/settings.vue?macro=true";
export default [
  {
    name: "account",
    path: "/account",
    meta: accountvSF4JG1laNMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/account.vue")
  },
  {
    name: "complete-account",
    path: "/complete-account",
    meta: complete_45accounte1FJFd9m83Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/complete-account.vue")
  },
  {
    name: "forgot-password",
    path: "/forgot-password",
    meta: forgot_45passwordf7is5a9jcNMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/forgot-password.vue")
  },
  {
    name: "home",
    path: "/home",
    meta: homeHoePjH8bA6Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/home.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexcpQ8zTU3ZFMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginrXwSMwVJ7KMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/login.vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsDNpDGgHymnMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/notifications.vue")
  },
  {
    name: "reset-password",
    path: "/reset-password",
    meta: reset_45passwordIiCxe9p0FFMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/reset-password.vue")
  },
  {
    name: inventoryRXsUnJlGH7Meta?.name,
    path: "/rollout-project/:rolloutIdentifier()/inventory",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-filters",
    path: "client-filters",
    meta: client_45filtersW7mmvIygSNMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-filters.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-client-groups",
    path: "client-groups",
    meta: client_45groupssDHwQ9nCRhMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/client-groups.vue")
  },
  {
    name: clientsj3k5RsLPrjMeta?.name,
    path: "clients",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-delivery-sheet-id",
    path: "delivery-sheet/:id()",
    meta: _91id_93g4vhNijwClMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/delivery-sheet/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients",
    path: "",
    meta: indexc9mtd8sZ3WMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-clients-view-id",
    path: "view/:id()",
    meta: _91id_93PF6JTihuQ4Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/clients/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-delivery-sheets",
    path: "delivery-sheets",
    meta: delivery_45sheets4tbXAbIYyVMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/delivery-sheets.vue")
  },
  {
    name: exportKD3kjuXGp5Meta?.name,
    path: "export",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-export",
    path: "",
    meta: indexBtDfGk3aS8Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-export-new",
    path: "new",
    meta: newjXhsoVbm7LMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/export/new.vue")
  }
]
  },
  {
    name: import1TwmsfioAIMeta?.name,
    path: "import",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-import",
    path: "",
    meta: indexsnyStGrJo6Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-new",
    path: "new",
    meta: newv63l8MjWjuMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/new.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-import-view-id",
    path: "view/:id()",
    meta: _91id_93SG005yz98PMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/import/view/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory",
    path: "",
    meta: indexcf83ZRNoiEMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/index.vue")
  },
  {
    name: inventoriesjKO0B0H8UTMeta?.name,
    path: "inventories",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-create",
    path: "create",
    meta: createk8JPH6t4idMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/create.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-dashboard-id",
    path: "dashboard/:id()",
    meta: _91id_939BfnrNxliMMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/dashboard/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories-edit-id",
    path: "edit/:id()",
    meta: _91id_93ry4Hb4xLnUMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/edit/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-inventory-inventories",
    path: "",
    meta: indexLTVnjaWbLmMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/inventory/inventories/index.vue")
  }
]
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-knowledge-base",
    path: "/rollout-project/:rolloutIdentifier()/knowledge-base",
    meta: indexIOSxZ4UdCbMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/knowledge-base/index.vue")
  },
  {
    name: reportingYN1wEZIGyvMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/reporting",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-reporting-activity",
    path: "activity",
    meta: activity8CyrsMmuSkMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/activity.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting-burndown",
    path: "burndown",
    meta: burndowntp5jcQQhL2Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/burndown.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-reporting",
    path: "",
    meta: index9jiidyCvVUMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/reporting/index.vue")
  }
]
  },
  {
    name: rolloutlT1PXgyBUYMeta?.name,
    path: "/rollout-project/:rolloutIdentifier()/rollout",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout.vue"),
    children: [
  {
    name: appointmentsRHfTaMDERyMeta?.name,
    path: "appointments",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments-id",
    path: ":id()",
    meta: _91id_935XhwXgbAnbMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/[id].vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-appointments",
    path: "",
    meta: indexr0HvhROOaUMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/appointments/index.vue")
  }
]
  },
  {
    name: client_45assignmentU3Bx9OfAN4Meta?.name,
    path: "client-assignment",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment",
    path: "",
    meta: index7XpsY4WC7SMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-assignment-inventory-id",
    path: "inventory/:id()",
    meta: _91id_93R1NLGj23kWMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-assignment/inventory/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-client-dashboard",
    path: "client-dashboard",
    meta: client_45dashboardbXSh3FCgSNMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/client-dashboard.vue")
  },
  {
    name: collaboratorsYmFLIYY9gAMeta?.name,
    path: "collaborators",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators",
    path: "",
    meta: indexy73hHT9PABMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-collaborators-profile-id",
    path: "profile/:id()",
    meta: _91id_93YTAB3ZG8zoMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/collaborators/profile/[id].vue")
  }
]
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout",
    path: "",
    meta: indexBH2WhOIIesMeta || {},
    alias: ["/rollout-project/:rolloutIdentifier()"],
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/index.vue")
  },
  {
    name: "rollout-project-rolloutIdentifier-rollout-roadmap",
    path: "roadmap",
    meta: roadmapLHK3lbmpMnMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/roadmap.vue")
  },
  {
    name: tasksLxnCnjw7Q6Meta?.name,
    path: "tasks",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks.vue"),
    children: [
  {
    name: "rollout-project-rolloutIdentifier-rollout-tasks",
    path: "",
    meta: indexgQuMuWvTTwMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/rollout-project/[rolloutIdentifier]/rollout/tasks/index.vue")
  }
]
  }
]
  },
  {
    name: "schedule-appointment",
    path: "/schedule-appointment",
    meta: schedule_45appointmentS5HIZm2uh6Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/schedule-appointment.vue")
  },
  {
    name: settings0WAvRF9SwcMeta?.name,
    path: "/settings",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings.vue"),
    children: [
  {
    name: "settings-branding",
    path: "branding",
    meta: brandingPjm9r4q0JOMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/branding.vue")
  },
  {
    name: checklists7zD7u2aISeMeta?.name,
    path: "checklists",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists.vue"),
    children: [
  {
    name: "settings-checklists-create",
    path: "create",
    meta: createI0QiafV9KQMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists/create.vue")
  },
  {
    name: "settings-checklists-edit-id",
    path: "edit/:id()",
    meta: _91id_932ANDu0xKQcMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists/edit/[id].vue")
  },
  {
    name: "settings-checklists",
    path: "",
    meta: indexbQJuXbcKa9Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/checklists/index.vue")
  }
]
  },
  {
    name: "settings-client-links",
    path: "client-links",
    meta: client_45linksaRe5LwbYU5Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/client-links.vue")
  },
  {
    name: "settings-custom-fields",
    path: "custom-fields",
    meta: custom_45fieldsl70iP2ESLEMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/custom-fields.vue")
  },
  {
    name: "settings",
    path: "",
    meta: index8FTFDc6bUfMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/index.vue")
  },
  {
    name: "settings-integrations",
    path: "integrations",
    meta: integrationsMGnxqdBQCPMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/integrations.vue")
  },
  {
    name: "settings-rollouts",
    path: "rollouts",
    meta: rolloutsNfusYJWkNFMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/rollouts.vue")
  },
  {
    name: "settings-subscription",
    path: "subscription",
    meta: subscriptiony8li3Wb2wOMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/subscription.vue")
  },
  {
    name: "settings-users",
    path: "users",
    meta: usersq8PvKeiuZIMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/users.vue")
  },
  {
    name: workflowsl0twXuKLX9Meta?.name,
    path: "workflows",
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows.vue"),
    children: [
  {
    name: "settings-workflows-create",
    path: "create",
    meta: createkUSyUIDvM6Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows/create.vue")
  },
  {
    name: "settings-workflows-edit-id",
    path: "edit/:id()",
    meta: _91id_93I4MTFX69B9Meta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows/edit/[id].vue")
  },
  {
    name: "settings-workflows",
    path: "",
    meta: index1rISvcDNlWMeta || {},
    component: () => import("/codebuild/output/src3758341090/src/packages/frontend/pages/settings/workflows/index.vue")
  }
]
  }
]
  }
]